module.exports = __webpack_public_path__ + "img/Sistema Nuvem.b7ba597c.png";